import { configurePlayerPreRollAds } from '../utils/brightcove-ad-targeting';
import {
	getNextEpisodeData,
	calculateRemainingTime,
	isWithinUpNextThreshold,
	setupUpNextCloseHandler,
	isAutoadvanceEnabled,
} from '../utils/discussion-room-utils';

const onReady =
	typeof window !== 'undefined' &&
	window.hmUtils &&
	typeof window.hmUtils.onDomContentLoad === 'function'
		? window.hmUtils.onDomContentLoad
		: function ( callback ) {
			if ( document.readyState === 'loading' ) {
				document.addEventListener( 'DOMContentLoaded', callback );
			} else {
				callback();
			}
		  };

const initDiscussionRoomPlayers = function () {
	if ( typeof window === 'undefined' || typeof document === 'undefined' ) {
		return;
	}

	window.dataLayer = window.dataLayer || [];

	// get data for the Up Next Pop Up
	const episodeList = document.querySelector( '.episode-list' );
	const nextEpisodeData = getNextEpisodeData( episodeList );
	const nextEpisodeUrl = nextEpisodeData?.nextEpisodeUrl;
	const nextEpisodeTitle = nextEpisodeData?.nextEpisodeTitle;
	const nextEpisodeRuntime = nextEpisodeData?.nextEpisodeRuntime;

	const upNextContainer = document.querySelector( '.up-next' );
	const upNextTitle = document.querySelector( '.up-next-title' );
	const upNextRuntime = document.querySelector( '.up-next-runtime' );

	const candidateElements = document.querySelectorAll(
		'.vjs-discussion-container video-js, .vjs-pip-container video-js, video-js[data-autoadvance]',
	);
	const playerElements = Array.from( candidateElements ).filter( ( el ) => {
		return (
			el.closest( '.vjs-discussion-container' ) ||
			el.hasAttribute( 'data-autoadvance' ) ||
			el.closest( '.vjs-pip-container' )?.querySelector( '.up-next' )
		);
	} );

	playerElements.forEach( ( playerElement ) => {
		if ( typeof videojs !== 'undefined' && ! playerElement.dataset.hmDiscussionPlayerInit ) {
			playerElement.dataset.hmDiscussionPlayerInit = '1';
			const playerInstance = videojs( playerElement );
			configurePlayerPreRollAds( playerInstance, playerElement );

			playerInstance.ready( function () {
				const myPlayer = this;
				configurePlayerPreRollAds( myPlayer, playerElement );

				let playEventLogged = false;

				myPlayer.on( 'playing', function () {

					const isAudio = playerElement.closest( '.wp-block-hm-brightcove-with-tracking' )?.classList.contains( 'is-audio' );
					const playerEvent = isAudio ? 'audio_start' : 'video_start';

					const videoTitle = myPlayer.mediainfo?.name;
					const playerId = myPlayer.bcinfo?.playerId;
					const videoId = myPlayer.mediainfo?.id;

					if ( !playEventLogged ) {
						window.dataLayer.push({
							'event': playerEvent,
							'videoTitle': videoTitle,
							'playerId': playerId,
							'videoId': videoId
						} );
						playEventLogged = true;
					}
				} );

				if ( nextEpisodeUrl ) {
					const autoadvanceEnabled = isAutoadvanceEnabled( playerElement );

					if ( upNextContainer ) {
						upNextContainer.href = nextEpisodeUrl;
					}
					if ( upNextTitle ) {
						upNextTitle.textContent = nextEpisodeTitle;
					}
					if ( upNextRuntime ) {
						upNextRuntime.textContent = nextEpisodeRuntime;
					}

					let upNextDismissed = false;
					const closeButton = document.querySelector( '.x-icon' );
					setupUpNextCloseHandler( closeButton, upNextContainer, () => {
						upNextDismissed = true;
					} );

					// display Up Next tile in player
					myPlayer.on( 'timeupdate', function () {
						const remainingTime = calculateRemainingTime( myPlayer.duration(), myPlayer.currentTime() );
						if ( isWithinUpNextThreshold( remainingTime ) && ! upNextDismissed && upNextContainer ) {
							upNextContainer.style.display = 'block';
						}
					} );

					// listen for end of video and advance page to the next episode
					if ( autoadvanceEnabled ) {
						myPlayer.on( 'ended', function () { 
							window.location.href = nextEpisodeUrl;
						} );
					}
				}
			} );
		}
	} );
};

export { initDiscussionRoomPlayers };

if ( typeof document !== 'undefined' && document.readyState !== 'loading' ) {
	initDiscussionRoomPlayers();
}
onReady( initDiscussionRoomPlayers );